<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bU2LPW/tc-custom/9781626565609.jpg?1737166238478" alt="This image is the cover for the book Work Reimagined"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Work Reimagined
      </h1>
      <p class="bookDescription body article font2">
        <p>DISCOVER WHAT YOU'RE HERE TO DO<br/><br/>It's the end of work as we know it. Career paths look nothing like they did in the days before phones got smart. We work more hours at more jobs for more years than ever before. So it's vital that we know how to find work that allows us to remain true to who we are in the deepest sense, work that connects us to something larger than ourselves‚Äîin short, our ‚Äúcalling.‚Äù We all have one, and bestselling authors Richard Leider and David Shapiro can help you uncover yours.<br/><br/>Through a unique Calling Card exercise that features a guided exploration of fifty-two ‚Äúnatural preferences‚Äù (such as Advancing Ideas, Doing the Numbers, Building Relationships, and Performing Events), Leider and Shapiro give us a new way to uncover our gifts, passions, and values and find work that expresses them. Along the way, they mix in dozens of inspiring true stories about people who have found, or are in the process of finding, their own callings.<br/><br/>Uncovering your calling enables you to experience fulfillment in all aspects and phases of your life. And here's the even better news: you'll never have to work again. When you choose to do what you are called to do, you're always doing what you want to do. Work Reimagined offers an enlightening, effective, and entertaining approach to discovering what you were born to do, no matter your age or stage of life.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard J. Leider, David A. Shapiro
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?624e5c45